import { all, takeLatest } from "redux-saga/effects";
import { ProfileTypes } from "Redux/ProfileRedux";
// import "regenerator-runtime/runtime";
import { ProfileApi } from "Services/ApiServices";
import {
  createProfile,
  getProfileLinksSaga,
  profile,
  profileUpdate,
  publicProfileSaga,
  updateAvatarRequestSaga,
  updateProfileLinksSaga,
} from "./workers";

/* ------------- API ------------- */

// We create our API
const api = ProfileApi.create();

/* ------------- Connect Types To Sagas ------------- */

export default function* profileRoot() {
  yield all([
    takeLatest(ProfileTypes.PROFILE_REQUEST, profile, api),
    takeLatest(ProfileTypes.PUBLIC_PROFILE_REQUEST, publicProfileSaga, api),
    takeLatest(ProfileTypes.PROFILE_UPDATE_REQUEST, profileUpdate, api),
    takeLatest(ProfileTypes.CREATE_PROFILE_REQUEST, createProfile, api),
    takeLatest(
      ProfileTypes.UPDATE_AVATAR_REQUEST,
      updateAvatarRequestSaga,
      api
    ),
    takeLatest(
      ProfileTypes.GET_PROFILE_LINKS_REQUEST,
      getProfileLinksSaga,
      api
    ),
    takeLatest(
      ProfileTypes.UPDATE_PROFILE_LINKS_REQUEST,
      updateProfileLinksSaga,
      api
    ),
  ]);
}
